// extracted by css-extract-rspack-plugin
export default {"body":"Presenter__body--BGx5u","bottomButtonsArea":"Presenter__bottomButtonsArea--vParZ","help":"Presenter__help--naF_N"};